import { GetEvent } from "Store/firebase/events";
import { Clone } from "js-vextensions";
import { AssertV, Command, MergeDBUpdates, AssertValidate } from "mobx-firelink";
import { UpdateBookEvent } from "./UpdateBookEvent";
import { SetBookEventIndex } from "./SetBookEventIndex";
//@UserEdit
export class RemoveEventCharacter extends Command {
    Validate() {
        AssertValidate({
            properties: {
                eventID: { $ref: "UUID" },
                characterID: { $ref: "UUID" },
            },
            required: ["eventID", "characterID"],
        }, this.payload, "Payload invalid");
        const { eventID, characterID } = this.payload;
        const event = GetEvent(eventID);
        AssertV(event, "event is null.");
        const newCharacters = Clone(event.characters);
        delete newCharacters[characterID];
        new UpdateBookEvent({ id: event._key, updates: { characters: newCharacters } }).Run();
        this.sub_updateEvent = new UpdateBookEvent({ id: eventID, updates: { characters: newCharacters } }).MarkAsSubcommand(this);
        this.sub_updateEvent.Validate();
        this.sub_updateOrder = new SetBookEventIndex({ characterID, eventID, index: null }).MarkAsSubcommand(this);
        this.sub_updateOrder.Validate();
    }
    GetDBUpdates() {
        let updates = {};
        updates = MergeDBUpdates(updates, this.sub_updateEvent.GetDBUpdates());
        updates = MergeDBUpdates(updates, this.sub_updateOrder.GetDBUpdates());
        return updates;
    }
}
